module.exports = __webpack_public_path__ + "img/sign_apply_apply.dbc5582f.png";